// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3OaPD","col":"styles_col__3UGAM"};